const $ = require('jquery');
const moment = require('moment');

// requires pikaday which is loaded through theme library
const PikadayResponsive = require('../../dist/vendor/pikaday-responsive.js');

const INTIAL_CENTER = {lat: 43.1975565, lng: -70.8776229};
const MAP_SECTION_ID = 'map';
let placeSearch;
let autocompleteStart;
let autocompleteEnd;
let map;
let beenLocated = false;
const $locationReverser = $('.locations__switcher__icon');
const $form = $('#trip-planner-form');
const $useMyLocation = $('.js-current-location');
const TRIP_PLANNER_URL = '/schedules/trip-planner';
let latlong;
let directionsDisplay;
let directionsService;
let doesSupportDateAndTime;
let globalResponse;

// //
// onready functions
// //////

// attach location reversing click
$locationReverser.click(reverseLocations);

// set up pikaday
if ($('#date').length) {
  const dateObject = PikadayResponsive(document.getElementById("date"), {
      format: "MM/DD/YY",
      outputFormat: "x",
      checkIfNativeDate: function() {
        // default function
        doesSupportDateAndTime = Modernizr.inputtypes.date && (Modernizr.touchevents && navigator.appVersion.indexOf("Win") === -1);
        if (doesSupportDateAndTime) {
          prefillDate();
          prefillTime();
        } else {
          prefillTime();
        }
        return doesSupportDateAndTime;
      },
      placeholder: "Date",
      dayOffset: 0,
      pikadayOptions: {
        defaultDate: moment().toDate(),
        setDefaultDate: true,
      }
  });
}

// locate when a field with js-geolocate class is clicked on
// this is used to bias the search results of locations
$('.js-geolocate').focus(e => {
  geolocate();
});

// attach click handler for user initiated geolocate
$useMyLocation.click(() => {
  if (!beenLocated) {
    // locate user if we haven't already, and then pass getAddress()
    // as a callback function
    geolocate(getAddress);
  } else {
    // if we've located user already, just call get address
    getAddress();
  }
});

// //
// onload functions
// /////////
$(window).on('load', () => {
  window.loaded = true;
});

// /////
// map trip
// /////////////
window.initMap = function() {
  // jump out of function if there's no form
  if ($form.length <= 0) {
    return false;
  }
  // items to always init
  directionsDisplay = new google.maps.DirectionsRenderer;
  directionsService = new google.maps.DirectionsService;
  const mapElement = document.getElementById(MAP_SECTION_ID);

  // for autocompleteStart
  // Create the autocompleteStart object, restricting the search to geographical
  // location types.
  autocompleteStart = new google.maps.places.Autocomplete((document.getElementById('start')), {
    types: ['geocode'],
  });

  autocompleteEnd = new google.maps.places.Autocomplete((document.getElementById('end')), {
    types: ['geocode'],
  });

  if (mapElement === null) {
    // if here, it means we're not on the map page
    const form = document.getElementById('trip-planner-form');
    // set the form action to the trip planner url
    $form[0].action = TRIP_PLANNER_URL;
  } else {
    // if not on map page, none of this will fire
    map = new google.maps.Map(mapElement, {
      center: INTIAL_CENTER,
      zoom: 10,
      zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
      },
      streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
      },
    });


    directionsDisplay.setPanel(document.getElementById('directions'));
    // directionsDisplay.setMap(map);

    google.maps.event.addListener(directionsDisplay, 'directions_changed', function() {
      setTimeout(() =>{
        // resize and set map after directions are loaded in
        google.maps.event.trigger(map, 'resize');
        directionsDisplay.setMap(map);
        updateFare();
      }, 500);
    });

    // attach form handler
    $form.submit( e => {
      e.preventDefault();
      calculateAndDisplayRoute();
    });

    // check if the form should be prefilled from URL
    // only after all handlers are attached and the form is on the map page
    checkForPrefill();
  }
};

function updateFare() {
  // this will get run once
  const routeIndex = directionsDisplay.getRouteIndex();
  setFarPrice(globalResponse.routes[routeIndex].fare.text);

  // and attach handlers to routelist options to update fare when new route is selected
  const selectItems = $('[jsaction="transitRouteList.selectRoute"]');
  selectItems.on('click', evt => {
    const routeIndex = evt.currentTarget.dataset.routeIndex;
    const curFare = globalResponse.routes[routeIndex].fare.text;
    setFarPrice(curFare);
  })
}

function setFarPrice(price) {
  const $fare = $('#fare');
  $fare.empty();
  $fare.html(`<span class="price">Selected Trip Fare: ${price}</span>`);
}

function calculateAndDisplayRoute() {
  const start = document.getElementById('start').value;
  const end = document.getElementById('end').value;
  const timeType = document.getElementById('timeOption').value;
  const time = document.getElementById('time').value;
  const date = (doesSupportDateAndTime) ? document.getElementById('date').value : document.getElementById('date-input').value;
  const formattedDate = Date.parse(`${date} ${time}`);

  directionsService.route(
    {
      origin: start,
      destination: end,
      travelMode: 'TRANSIT',
      provideRouteAlternatives: true,
      transitOptions: {
        [timeType]: formattedDate,
        modes: ['BUS'],
        routingPreference: 'LESS_WALKING',
      },
    }, function(response, status) {
      if (status === 'OK') {
        $('#directions').empty(); // this will clear out 'no results' message if it exists
        globalResponse = response;
        directionsDisplay.setDirections(response);
        console.log(response);
        setTimeout(function(){
          $('.weekday').remove();
          for (var i = 0; i < response['routes'].length; i++) { 
            var route_day = response['routes'][i]['legs'][0]['arrival_time'].value.toString();
            console.log(i);
            var j = i+1;
            $('#directions > div:nth-child(1) > div > div:nth-child(2) > ol > li:nth-child('+j+') > div:nth-child(3)').append(' <span class="weekday">'+route_day.split(' ')[0]+'</span>');
          }
        },1000); 
      } else {
        // not okay
        switch(status) {
          case 'ZERO_RESULTS':
            $('#directions').html('<div class="no-results">There are no results! Please try another search</div>');
            break;
          default:
            window.alert('Directions request failed due to ' + status);
        }
      }
    }
  );

  if (window.innerWidth < 800) {
    // move immediately if window has been loaded
    if (window.loaded) {
      $(`#${MAP_SECTION_ID}`).smoothScrollTo({ duration: 500 });
    } else {
      // otherwise wait for load
      // then move
      $(window).on('load', () => {
        $(`#${MAP_SECTION_ID}`).smoothScrollTo({ duration: 500 });
      });
    }

  }
}

// function to prefill date and time fields with current information
  function prefillDate() {
    const today = new Date().toISOString().substr(0, 10);

    const dateinputs = $('input[type="date"]');

    dateinputs.each((key, input) => {
      input.value = today;
    });
  }

function prefillTime() {
  const today = new Date().toISOString().substr(0, 10);

  const timeinputs = $('input[type="time"]');

  timeinputs.each((key, input) => {
    const d = new Date();
    const h = (d.getHours() < 10 ? '0' : '') + d.getHours();
    const  m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    // alert(`${h}:${m}`);
    input.value = `${h}:${m}`;
  });
}

// this gets called on focus to set bounds of autocompleter
function geolocate(callback) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition( position => {
      latlong = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      const accuracy = position.coords.accuracy;
      setBounds(latlong, accuracy);
      beenLocated = true;
      if (typeof callback === 'function') {
        callback();
      }
    });
    return true;
  }
  return false;
}

function setBounds(coords, accuracy) {
  const circle = new google.maps.Circle({
    center: coords,
    radius: accuracy,
  });
  if (autocompleteStart != null && autocompleteEnd != null) {
    autocompleteStart.setBounds(circle.getBounds());
    autocompleteEnd.setBounds(circle.getBounds());
  }
}

function getAddress() {
  const geocoder = new google.maps.Geocoder;
  geocoder.geocode({'location': latlong}, (results, status) => {
    if (status === 'OK') {
      if (results[0]) {
        document.getElementById('start').value = results[0].formatted_address;
      } else {
        window.alert('No results found');
      }
    } else {
      window.alert('Geocoder failed due to:' + status);
    }
  });
}

// swap start and end locations
function reverseLocations() {
  const start = document.getElementById('start');
  const startValue = document.getElementById('start').value;
  const end = document.getElementById('end');
  const endValue = document.getElementById('end').value;
  start.value = endValue;
  end.value = startValue;
}

function checkForPrefill() {
  const query = window.location.search.substring(1);
  if (query) {
    const qs = parse_query_string(query);
    if (qs.starting_location) {
      document.getElementById('start').value = qs.starting_location.replace(/\+/g, ' ');
    }

    if (qs.ending_location) {
      document.getElementById('end').value = qs.ending_location.replace(/\+/g, ' ');
    }

    if (qs.time) {
      document.getElementById('time').value = qs.time.replace(/\+/g, ' ');
    }

    if (qs.date) {
      document.getElementById('date').value = qs.date.replace(/\+/g, ' ');
    }

    // js does not let you submit a form and have event handlers trigger,
    // so call same function as when form is sumbitted
    calculateAndDisplayRoute();
  }
}

function parse_query_string(query) {
  const vars = query.split("&");
  const query_string = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    // If first entry with this name
    if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof query_string[pair[0]] === "string") {
      const arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
      query_string[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  return query_string;
}
